// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3q1Ar","label":"CategoryService_label__7BwXM","location":"CategoryService_location__32VV1"};